import createStaticRef from '../../Core/Helpers/createStaticRef'

const modalProps = createStaticRef()

export default modalProps
